const defaultAnimationStore = {
    play: true,
    fps: 20
};
const defaultAutomatonDimensionsStore = {
    W: 50,
    H: 50
};
const defaultColorStore = {
    background: { H: 307, S: 87, B: 36 },
    fill: { H: 157, S: 88, B: 36 },
    firstLineFill: { H: 37, S: 88, B: 36 }
};
const defaultRule = 22;
const defaultDenerationControlsStore = {
    lastReset: 0,
    enableAutomaticGeneration: true,
    interval: 1000
};
const defaultGenerationSettingsStore = {
    W: false,
    H: false,
    rule: true,
    firstLine: true,
    color: true,
    firstLineDensity: 50
};
const defaultViewStore = {
    square: true,
    circle: true,
    circle_inv: true,
    p5_webgl: false
};
const AUTOMATON_MAX_DIMENSIONS = {
    W: 200,
    H: 200
};
export { AUTOMATON_MAX_DIMENSIONS, defaultAnimationStore, defaultAutomatonDimensionsStore, defaultColorStore, defaultDenerationControlsStore, defaultGenerationSettingsStore, defaultRule, defaultViewStore };
